function megaMenuMainTabHover(event, id) {
    if (window.innerWidth > 1200) {
        const allContent = document.querySelectorAll('.megaMenu-content');
        const imgContent = document.querySelectorAll('.megaMenu-image-content');

        // Hide all content
        allContent.forEach(content => content.classList.remove('active'));

        // // only show the first content
        // document.querySelector(`div[data-content="megaMenuSubTab-${id}-1"]`).classList.add('active');

        // only show the image content
        imgContent.forEach(imgContent => imgContent.classList.add('active'));
    }
}

// Select all sub-tabs and add hover event listeners
const subTabs = document.querySelectorAll('.megaMenu-sub-tab');

// Function to show content based on hovered sub-tab
function handleSubTabHover(event) {
    if (window.innerWidth > 1200) {
        const subTabId = event.target.dataset.subTab;  // Get the data-sub-tab value
        const allContent = document.querySelectorAll('.dsktop-mega-content');
        const imgContent = document.querySelectorAll('.megaMenu-image-content');
        
        // Hide all content
        imgContent.forEach(imgContent => imgContent.classList.remove('active'));
        allContent.forEach(content => content.classList.remove('active'));
        
        // Show the corresponding content
        const contentToShow = document.querySelector(`.dsktop-mega-content[data-content="${subTabId}"]`);
        if (contentToShow) {
            contentToShow.classList.add('active');
        }
    }
}

// Add hover event to all sub-tabs
subTabs.forEach(subTab => {
    subTab.addEventListener('mouseenter', handleSubTabHover);
});
